import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DataExchangeService} from '../../../../../surface3d/src/lib/API/Public/data-exchange.service';

@Component({
    selector: 'burncase-target-adaption',
    templateUrl: './target-adaption.component.html',
    styleUrls: ['./target-adaption.component.css']
})
export class TargetAdaptionComponent implements OnInit {

    @Input() sliderValue = 0;
    @Input() headerName = '';
    @Input() sliderId = -1;
    @Input() unitSlider = '';
    @Input() sliderMin = 0;
    @Input() sliderMax = 10;
    @Input() sliderStep = 1;
    @Input() inputMin = 0;
    @Input() inputMax = 10;
    @Input() inputStep = 1;
    @Input() inputName = '';
    @Output() sliderResult = new EventEmitter<{ id: number, value: number }>();
    @ViewChild('input') input;
    @ViewChild('inputBMI') inputBMI;

    constructor(public dataExchangeService: DataExchangeService) {
    }

    ngOnInit(): void {
    }

    /**
     * One of the sliders or input from model view changed. Call related method selected through slider id.
     * sliderId 1 = Height slider, sliderId 2 = age slider, sliderId 3 = weight slider
     * @param value the current value of the slider.
     */
    onSliderChange(value: number): void {
        // set value of input in realtime if slider is moved
        if (this.input) {
            this.input.nativeElement.value = value;
        } else {
            this.inputBMI.nativeElement.value = ((value + 0.3) / 0.3 * 5 + 10).toFixed(2);
        }

        // sets val of dataexchangeservice to true because model has changed
        this.dataExchangeService.patient.modelChanged = true;

        switch (this.sliderId) {
            case 1: {
                this.dataExchangeService.patient.height = value;
                break;
            }

            case 2: {
                this.dataExchangeService.patient.age = value;
                this.setAgeInfluences(value);
                break;
            }

            case 3: {
                // this.dataExchangeService.modelWeight = this.inputBMI.nativeElement.value *
                //     ((this.dataExchangeService.modelHeight / 100) ^ 2);
                this.dataExchangeService.patient.bmi = this.inputBMI.nativeElement.value;
                // this.dataExchangeService.setTargetInfluence(value, 6, true);
                break;
            }
        }
        // returns slider id and value to set weight limit on specific age value
        this.sliderResult.emit({id: this.sliderId, value: value});
    }

    /**
     * Sets the different targets of the model to represent the correct age.
     * Target 0 --> female_adult to 14.5 years
     * Target 1 --> 14.5 to 8.75 years
     * Target 2 --> 8.75 to 5 years
     * Target 3 --> 5 to 3.25 years
     * Target 4 --> 3.25 to 1.75 years
     * Target 5 --> 1.75 to 0.5 years
     * Target 6 --> corpulent slider
     * @param value age of the model.
     */
    setAgeInfluences(value: number) {
        this.dataExchangeService.patient.setAgeInfluences(value, true);
    }

    onChangeBMI(value: number): void {
        this.sliderValue = ((value - 10) / 5) * 0.3 - 0.3;
        this.onSliderChange(this.sliderValue);
    }
}
